import React, { useRef } from 'react';
import styled from '@emotion/styled';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Color } from '@sunrun/mui-theme';
import QuestionSectionComponent from '../faq/QuestionSectionComponent.jsx';
import { StyledBackground, Container } from './SharedElements';

const Content = styled.div`
  flex: 1 0 auto;
`;

const HeadingSection = styled.div`
  color: ${Color.BLACK_85};
  padding: 15px 15px 20px 10px;
  font-weight: bold;
  background-color: ${Color.WHITE};
`;

const AdditionalTextSection = styled.div`
  color: ${Color.BLACK_85};
  padding-left: 10px;
  padding-bottom: 10px;
`;

const IndivFAQSection = ({
  additionalText,
  customCardWidth,
  dataTestId,
  headerText,
  leftFeedbackMixpanelMessage,
  questions,
  route,
  viewedQMixpanelMessage,
}) => {
  const { push } = useHistory();
  const scrollContainerRef = useRef();
  const onQuestionSelect = question => {
    const { link } = question;
    const url = `${route}#${link}`;
    push(url);
  };
  return (
    <StyledBackground>
      <Content data-testid={dataTestId}>
        <Container indivFAQ customCardWidth={customCardWidth}>
          {headerText && <HeadingSection>{headerText}</HeadingSection>}
          {additionalText && <AdditionalTextSection>{additionalText}</AdditionalTextSection>}
          <QuestionSectionComponent
            questions={questions}
            onQuestionSelect={onQuestionSelect}
            scrollContainerRef={scrollContainerRef}
            viewedQMixpanelMessage={viewedQMixpanelMessage}
            leftFeedbackMixpanelMessage={leftFeedbackMixpanelMessage}
            titleFontSize="16px"
          />
        </Container>
      </Content>
    </StyledBackground>
  );
};

IndivFAQSection.propTypes = {
  additionalText: PropTypes.element,
  customCardWidth: PropTypes.string,
  dataTestId: PropTypes.string,
  leftFeedbackMixpanelMessage: PropTypes.string.isRequired,
  viewedQMixpanelMessage: PropTypes.string.isRequired,
  questions: PropTypes.array.isRequired,
  headerText: PropTypes.string,
  route: PropTypes.string.isRequired,
};

IndivFAQSection.defaultProps = {
  additionalText: null,
  customCardWidth: null,
  dataTestId: '',
  headerText: '',
};

export default IndivFAQSection;
